<app-nav-menu></app-nav-menu>
<div class="container py-4">
  <span class="text-success mb-3">Dashboard <i class="fas fa-angle-right"></i> Search (Step 1)</span>
  <div class="row mb-4">
    <div class="col-lg-8 mx-auto text-center">
      <h4 class="text-dark fw-lighter">Travel Details</h4>
    </div>
  </div>

  <div class="row" #target>
    <div class="col-lg-12 mx-auto">
      <div class="solution_card p-5">
        <ul role="tablist" class="nav bg-light nav-pills nav-fill mb-3">
          <li class="nav-item" [ngClass]="{'active': tripType === 'oneway'}">
            <a data-toggle="pill" href="#nav-tab-card" class="nav-link active" (click)="checktriptype('oneway')">
              <i class="fas fa-circle"></i>
              One Way
            </a>
          </li>
          <li class="nav-item" [ngClass]="{'active': tripType === 'roundtrip'}">
            <a data-toggle="pill" href="#nav-tab-paypal" class="nav-link" (click)="checktriptype('roundtrip')">
              <i class="fas fa-circle"></i>
              Return
            </a>
          </li>
        </ul>
        <div class="form-group">
          <label>
            <input type="radio" name="locationType" [(ngModel)]="locationType" value="country">
            Country
          </label>
          <label class="ml-3">
            <input type="radio" name="locationType" [(ngModel)]="locationType" value="city">
            City
          </label>
        </div>
        <form role="form" (ngSubmit)="onSubmit(insuranceForm)" #insuranceForm="ngForm">

          @if (locationType === 'country') {
            <div class="row">
              <div class="col-lg-6 col-md-6 col-sm-12">
                <div class="form-group">
                  <p-select class="segmentDropdown"
                    id="fromrtcc"
                    name="fromrt"
                    placeholder="Select From Country"
                    [options]="countryList"
                    optionLabel="countryName"
                    optionValue="code"
                    [filter]="true"
                    filterBy="countryName"
                    required ngModel #fromrt="ngModel">
                  </p-select>
                  <span class="highlight"></span>
                  <span class="bar"></span>
                  <label class="labelofmodifyserachinputs">
                    FROM COUNTRY *
                  </label>
                </div>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-12">
                <div class="form-group">
                  <p-select class="segmentDropdown"
                    id="gotortcc"
                    name="goingtort"
                    placeholder="Select To Country"
                    [options]="countryList"
                    optionLabel="countryName"
                    optionValue="code"
                    [filter]="true"
                    filterBy="countryName"
                    required ngModel #fromrt="ngModel">
                  </p-select>
                  <span class="highlight"></span>
                  <span class="bar"></span>
                  <label class="labelofmodifyserachinputs">
                    TO COUNTRY *
                  </label>
                </div>
              </div>
            </div>
          }
          @if (locationType === 'city') {
            <div class="row">
              <div class="col-lg-6 col-md-6 col-sm-12">
                <div class="form-group">
                  <p-select  class="segmentDropdown"
                    [options]="countryCityList"
                    id="fromrtcc"
                    name="fromrt"
                    optionLabel="cityName"
                    optionValue="code"
                    placeholder="Select From City"
                    [filter]="true"
                    filterBy="cityName"
                    appendTo="body"
                    ngModel
                    required>
                  </p-select>
                  <span class="highlight"></span>
                  <span class="bar"></span>
                  <label class="labelofmodifyserachinputs">
                    FROM City *
                  </label>
                </div>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-12">
                <div class="form-group">
                  <p-select class="segmentDropdown"
                    id="gotortcc"
                    name="goingtort"
                    [options]="countryCityList"
                    optionLabel="cityName"
                    optionValue="code"
                    placeholder="Select To City"
                    [filter]="true"
                    filterBy="cityName"
                    appendTo="body"
                    ngModel
                    required>
                  </p-select>
                  <span class="highlight"></span>
                  <span class="bar"></span>
                  <label class="labelofmodifyserachinputs">
                    TO City *
                  </label>
                </div>
              </div>
            </div>
          }
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12">
              <div class="form-group">
                <input type="date" class="inputStyle" name="departuredatert" required ngModel [min]="minDate" #departuredatert="ngModel" view="date">
                <span class="highlight"></span>
                <span class="bar"></span>
                <label class="labelofmodifyserachinputs">Deaprture DATE *</label>
              </div>
            </div>

            @if (returndate) {
              <div class="col-lg-6 col-md-6 col-sm-12">
                <div class="form-group">
                  <input type="date" class="inputStyle" name="returndate" [min]="minDate" required ngModel #returndate="ngModel" view="date">
                  <span class="highlight"></span>
                  <span class="bar"></span>
                  <label class="labelofmodifyserachinputs">Return DATE *</label>
                </div>
              </div>
            }
          </div>
          <!--<div class="row">
          <div class="col-lg-6 col-md-6 col-sm-12">
            <div class="form-group">
              <div class="p-float-label" style="width: 100% !important; top:8px;">-->
                <!-- <p-multiSelect [options]="airlineMasterinfo"
                [style]="{ width: '100%' }"
                [filter]="true"
                placeholder="e.g. EK, QR..."
                optionLabel="airlineName"
                optionValue="airlineCombineCode"
                [ngModelOptions]="{standalone: true}"
                [panelStyle]="{ 'width': '1em' }"
                panelHideOnClickOutside="false"
                [selectionLimit]="3" ngModel #departureairlinecodert="ngModel">
              </p-multiSelect> -->
              <!--<p-select class="segmentDropdown"
              [options]="airlineMasterinfo"
              optionLabel="airlineLegalName"
              optionValue="airlinePrefixCode"
              [filter]="true"
              filterBy="airlineLegalName"
              name="departureairlinecodert"
              placeholder="Select Airline"
              required ngModel #departureairlinecodert="ngModel">
            </p-select>
            <label for="float-labels">Select Airline*</label>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12">
      </div>
    </div>-->
    <hr />
    <label class="d-block mt-3"><span class="hidden-xs text-lg-start text-uppercase">No. of Passengers</span></label>
    <div class="row mt-1">
      <div class="col-lg-4 col-md-6 col-sm-12">
        <div class="form-group">
          <p-select class="segmentDropdown"
            name="adultrt"
            [options]="adultList"
            optionLabel="adultItem"
            optionValue="adultItem"
            required [(ngModel)]="adultCountRT" (change)="ChangeOnewayAdult(adultCountRT)">
          </p-select>
          <span class="highlight"></span>
          <span class="bar"></span>
          <label class="labelofmodifyserachinputs text-uppercase">
            Adult
          </label>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-12">
        <div class="form-group">
          <p-select class="segmentDropdown"
            name="childrt"
            [options]="ChildItem"
            placeholder="0"
            required
            [(ngModel)]="childCountRT"
            (change)="ChangeOnewayChildAge(childCountRT)">
          </p-select>
          <span class="highlight"></span>
          <span class="bar"></span>
          <label class="labelofmodifyserachinputs text-uppercase">
            Children
          </label>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-12">
        <div class="form-group">
          <p-select class="segmentDropdown"
            name="infantrt"
            [options]="InfantItem"
            required
            [(ngModel)]="infantCountRT"
            (change)="ChangeOnewayInfantAge(infantCountRT)">
          </p-select>
          <span class="highlight"></span>
          <span class="bar"></span>
          <label class="labelofmodifyserachinputs text-uppercase">
            Infant
          </label>
        </div>
      </div>
    </div>
    <hr />
    <div class="row mt-3">
      <div class="col-lg-3 col-md-3 col-sm-12 mb-1">
        <button type="button" class="subscribe btn btn-block shadow-sm text-uppercase" (click)="ToDashboard()"><i class="fas fa-angle-double-left"></i> Dashboard  </button>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12">
      </div>
      <div class="col-lg-3 col-md-3 col-sm-12">
        <button type="submit" [disabled]="!insureRoundTripForm.valid" class="subscribe btn btn-block shadow-sm text-uppercase"> View Plans <i class="fas fa-angle-double-right"></i> </button>
      </div>
    </div>
  </form>


</div>
</div>
</div>
</div>

<router-outlet></router-outlet>

